









import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import OwnerForm from './OwnerForm.vue';
import * as ownerService from '@/services/owner';
import { Owner } from "@/api/owner/types";

@Component({
  name: 'OwnerFormController',
  components: {
    OwnerForm,
  }
})
export default class OwnerFormController extends Vue {
  @Prop(String)
  private readonly ownerUuid!: string;

  private formState: string = '';

  private async mounted() {
    await this.onOwnerUuidChanged(this.ownerUuid);
  }

  @Watch('ownerUuid')
  private onOwnerUuidChanged(ownerUuid?: string) {
    if (!ownerUuid) {
      this.formState = 'initial';
      this.$nextTick(async () => {
        await ownerService.clearOwner();
      });
    } else {
      this.formState = 'fetching:by-id';
      this.$nextTick(async () => {
        await ownerService.fetchOwnerByUuid(ownerUuid);
      });
    }
  }

  get ownerStatus() {
    return this.$store.state.owner.status;
  }

  get owner() {
    return this.$store.state.owner.ownerContext;
  }

  @Watch('ownerStatus', { immediate: true })
  private onOwnerStatusChanged(ownerStatus: string, oldStatus: string) {
    if (ownerStatus === 'no-owner') {
      this.clearRoute();
    }

    if (ownerStatus === 'fetch:no-owner') {
      this.formState = 'fetch:no-owner';
      this.clearRoute();

      if (oldStatus === 'fetching:by-id') {
        this.clearOwner();
      }
    }
    
    if (ownerStatus === 'fetch:by-key') {
      this.formState = 'fetch:owner';
      this.saveRoute(this.owner.uuid);
    }

    if (ownerStatus === 'fetch:by-id') {
      this.formState = 'fetch:owner';
      this.saveRoute(this.owner.uuid);
    }
    
    if (ownerStatus === 'fetch:owner') {
      this.formState = 'fetch:owner';
      this.saveRoute(this.owner.uuid);
    }
  }

  private async clearOwner() {
    await ownerService.clearOwner();
  }

  private clearRoute() {
    if (!!this.ownerUuid) {
      // @ts-ignore
      this.$router.replace({params: { ownerUuid: undefined }});
    }
  }

  private saveRoute(ownerUuid: string) {
    if (!this.ownerUuid) {
      this.$router.replace({params: { ownerUuid }});
    }
  }

  private fetchOwnerByKey(ownerKey: string) {
    ownerService.fetchOwnerByOwnerKey(ownerKey);
  }

  private fetchByUuid(ownerUuid: string) {
    ownerService.fetchOwnerByUuid(ownerUuid);
  }

  private submitOwner(owner: Owner) {
    ownerService.submitOwner(owner);
  }
}
